import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/shared/CategoryHeaderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/shared/ProductList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/vassses.png");
